export default __webpack_public_path__ + "static/media/results@2x.9fd28afc.png";